import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as DIDManagementAPI from 'api/DIDManagement';
import { dispatch } from 'store';
import { TYPE_OF_FIELD_IN_COLUMN } from 'utils/scorecard';
import { openSnackbar } from 'store/reducers/snackbar';

const displayMessage = ({ type, msg }) => {
  dispatch(
    openSnackbar({
      open: true,
      message: msg ? msg : type === 'success' ? 'Success' : 'Something went wrong',
      variant: 'alert',
      alert: {
        color: type || 'success'
      },
      close: false
    })
  );
};

const initialState = {
  pagination: {
    pageSize: 10,
    currentPage: 1,
    totalRecords: null
  },
  column: [
    { title: '#', key: 'id', field_type: TYPE_OF_FIELD_IN_COLUMN.NUMBER, width: 120 },
    { title: 'Caller Id', key: 'caller_id', field_type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 210 },
    { title: 'SIP Trunk', key: 'sip_trunk', field_type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 120 },
    { title: 'Status', key: 'status', field_type: TYPE_OF_FIELD_IN_COLUMN.STATUS, width: 120 },
    { title: 'Action', key: 'actions', field_type: TYPE_OF_FIELD_IN_COLUMN.ACTIONS, width: 120 }
  ],
  data: null,
  customerDid: {
    pagination: {
      pageSize: 10,
      currentPage: 1,
      totalRecords: null
    },
    column: [
      { title: '#', key: 'id', field_type: TYPE_OF_FIELD_IN_COLUMN.NUMBER, width: 120 },
      { title: 'Caller Id', key: 'did.caller_id', field_type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 210 },
      { title: 'SIP Trunk', key: 'did.sip_trunk', field_type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 120 },
      { title: 'Status', key: 'did.status', field_type: TYPE_OF_FIELD_IN_COLUMN.STATUS, width: 120 },
      { title: 'Action', key: 'actions', field_type: TYPE_OF_FIELD_IN_COLUMN.ACTIONS, width: 120 }
    ],
    data: null,
    allPublicDIDData: []
  },
  inboundDID: {
    pagination: {
      pageSize: 10,
      currentPage: 1,
      totalRecords: null
    },
    column: [
      { title: '#', key: 'id', field_type: TYPE_OF_FIELD_IN_COLUMN.NUMBER, width: 120 },
      { title: 'DID', key: 'did.caller_id', field_type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 210 },
      { title: 'Country', key: 'did.country', field_type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 120 },
      { title: 'SIP Trunk', key: 'did.sip_trunk', field_type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 120 },
      { title: 'Customer', key: 'customer.name', field_type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 120 }
      // { title: 'Action', key: 'actions', field_type: TYPE_OF_FIELD_IN_COLUMN.ACTIONS, width: 120 }
    ],
    data: null,
    allCustomersData: []
  },
  inboundTrunks: {
    pagination: {
      pageSize: 10,
      currentPage: 1,
      totalRecords: null
    },
    column: [
      { title: 'SIP Trunk ID', key: 'sip_trunk_id', field_type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 180 },
      { title: 'Name', key: 'name', field_type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 150 },
      { title: 'Numbers', key: 'numbers', field_type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 180 },
      { title: 'Auth Username', key: 'auth_username', field_type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 150 },
      { title: 'Krisp Enabled', key: 'krisp_enabled', field_type: TYPE_OF_FIELD_IN_COLUMN.STATUS, width: 120 },
      { title: 'Media Encryption', key: 'media_encryption', field_type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 180 },
      { title: 'Action', key: 'actions', field_type: TYPE_OF_FIELD_IN_COLUMN.ACTIONS, width: 120 }
    ],
    data: []
  },
  outboundTrunks: {
    pagination: {
      pageSize: 10,
      currentPage: 1,
      totalRecords: null
    },
    column: [
      { title: 'SIP Trunk ID', key: 'sip_trunk_id', field_type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 180 },
      { title: 'Name', key: 'name', field_type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 150 },
      { title: 'Numbers', key: 'numbers', field_type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 180 },
      { title: 'Auth Username', key: 'auth_username', field_type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 150 },
      { title: 'Krisp Enabled', key: 'krisp_enabled', field_type: TYPE_OF_FIELD_IN_COLUMN.STATUS, width: 120 },
      { title: 'Media Encryption', key: 'media_encryption', field_type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 180 },
      { title: 'Action', key: 'actions', field_type: TYPE_OF_FIELD_IN_COLUMN.ACTIONS, width: 120 }
    ],
    data: null
  },
  dispatchRules: {
    pagination: {
      pageSize: 10,
      currentPage: 1,
      totalRecords: null
    },
    column: [
      { title: 'Dispatch Rule ID', key: 'sip_dispatch_rule_id', field_type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 200 },
      { title: 'Name', key: 'name', field_type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 180 },
      { title: 'Trunk IDs', key: 'trunk_ids', field_type: TYPE_OF_FIELD_IN_COLUMN.ARRAY, width: 180 },
      { title: 'Hide Phone Number', key: 'hide_phone_number', field_type: TYPE_OF_FIELD_IN_COLUMN.STATUS, width: 150 },
      { title: 'Krisp Enabled', key: 'krisp_enabled', field_type: TYPE_OF_FIELD_IN_COLUMN.STATUS, width: 120 },
      { title: 'Media Encryption', key: 'media_encryption', field_type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 180 },
      { title: 'Action', key: 'actions', field_type: TYPE_OF_FIELD_IN_COLUMN.ACTIONS, width: 120 }
    ],
    data: null
  },
  status: '',
  ui: {
    loading: false,
    msg: ''
  }
};

const getDIDManagementData = createAsyncThunk('didManagement/getDIDManagementData', async ({ params, signal }) => {
  const res = await DIDManagementAPI.getDIDManagementData(params, signal);
  return res?.data?.data;
});

const createDIDManagement = createAsyncThunk('didManagement/createDIDManagement', async (params) => {
  try {
    const res = await DIDManagementAPI.createDIDManagement(params);
    displayMessage({ type: 'success', msg: 'Created successfully' });
    return res.data?.data;
  } catch (error) {
    displayMessage({ type: 'error', msg: error?.message });
  }
});

const updateDIDManagement = createAsyncThunk('didManagement/updateDIDManagement', async (params) => {
  try {
    const res = await DIDManagementAPI.updateDIDManagement(params);
    displayMessage({ type: 'success', msg: 'Updated successfully' });
    return res.data?.data;
  } catch (error) {
    displayMessage({ type: 'error', msg: error?.message });
  }
});

const deleteDIDManagement = createAsyncThunk('didManagement/deleteDIDManagement', async (id) => {
  try {
    const res = await DIDManagementAPI.deleteDIDManagement(id);
    displayMessage({ type: 'success', msg: 'Deleted successfully' });
    return res.data?.data;
  } catch (error) {
    displayMessage({ type: 'error', msg: error?.message });
  }
});

const getAllPublicDIDManagementData = createAsyncThunk('didManagement/getAllPublicDIDManagementData', async () => {
  const res = await DIDManagementAPI.getAllPublicDIDManagementData();
  return res?.data?.data;
});

const getCustomerDIDManagementData = createAsyncThunk('didManagement/getCustomerDIDManagementData', async ({ params, signal }) => {
  const res = await DIDManagementAPI.getCustomerDIDManagementData(params, signal);
  return res?.data?.data;
});

const attachCustomerDIDManagement = createAsyncThunk('didManagement/attachCustomerDIDManagement', async (params) => {
  try {
    const res = await DIDManagementAPI.attachCustomerDIDManagement(params);
    displayMessage({ type: 'success', msg: 'Attached successfully' });
    return res.data?.data;
  } catch (error) {
    displayMessage({ type: 'error', msg: error?.message });
  }
});

const deleteCustomerDIDManagement = createAsyncThunk('didManagement/deleteCustomerDIDManagement', async (id) => {
  try {
    const res = await DIDManagementAPI.deleteCustomerDIDManagement(id);
    displayMessage({ type: 'success', msg: 'Deleted successfully' });
    return res.data?.data;
  } catch (error) {
    displayMessage({ type: 'error', msg: error?.message });
  }
});

const getInboundDIDData = createAsyncThunk('didManagement/getInboundDIDData', async ({ params, signal }) => {
  const res = await DIDManagementAPI.getInboundDIDData(params, signal);
  return res?.data?.data;
});

const createInboundDID = createAsyncThunk('didManagement/createInboundDID', async (params) => {
  try {
    const res = await DIDManagementAPI.createInboundDID(params);
    displayMessage({ type: 'success', msg: 'Created successfully' });
    return res.data?.data;
  } catch (error) {
    displayMessage({ type: 'error', msg: error?.message });
  }
});

const updateInboundDID = createAsyncThunk('didManagement/updateInboundDID', async (params) => {
  try {
    const res = await DIDManagementAPI.updateInboundDID(params);
    displayMessage({ type: 'success', msg: 'Updated successfully' });
    return res.data?.data;
  } catch (error) {
    displayMessage({ type: 'error', msg: error?.message });
  }
});

const deleteInboundDID = createAsyncThunk('didManagement/deleteInboundDID', async (id) => {
  try {
    const res = await DIDManagementAPI.deleteInboundDID(id);
    displayMessage({ type: 'success', msg: 'Deleted successfully' });
    return res.data?.data;
  } catch (error) {
    displayMessage({ type: 'error', msg: error?.message });
  }
});

const getAllCustomersData = createAsyncThunk('didManagement/getAllCustomersData', async () => {
  const res = await DIDManagementAPI.getAllCustomersData();
  return res?.data?.data;
});

// Inbound Trunks Actions
const getInboundTrunksData = createAsyncThunk('didManagement/getInboundTrunksData', async ({ params, signal }) => {
  const res = await DIDManagementAPI.getInboundTrunksData(params, signal);
  return res?.data?.data;
});

const createInboundTrunk = createAsyncThunk('didManagement/createInboundTrunk', async (params) => {
  try {
    const res = await DIDManagementAPI.createInboundTrunk(params);
    displayMessage({ type: 'success', msg: 'Inbound trunk created successfully' });
    return res.data?.data;
  } catch (error) {
    displayMessage({ type: 'error', msg: error?.message });
  }
});

const updateInboundTrunk = createAsyncThunk('didManagement/updateInboundTrunk', async (params) => {
  try {
    const res = await DIDManagementAPI.updateInboundTrunk(params);
    displayMessage({ type: 'success', msg: 'Inbound trunk updated successfully' });
    return res.data?.data;
  } catch (error) {
    displayMessage({ type: 'error', msg: error?.message });
  }
});

const deleteInboundTrunk = createAsyncThunk('didManagement/deleteInboundTrunk', async (id) => {
  try {
    const res = await DIDManagementAPI.deleteInboundTrunk(id);
    displayMessage({ type: 'success', msg: 'Inbound trunk deleted successfully' });
    return res.data?.data;
  } catch (error) {
    displayMessage({ type: 'error', msg: error?.message });
  }
});

// Outbound Trunks Actions
const getOutboundTrunksData = createAsyncThunk('didManagement/getOutboundTrunksData', async ({ params, signal }) => {
  const res = await DIDManagementAPI.getOutboundTrunksData(params, signal);
  return res?.data?.data;
});

const createOutboundTrunk = createAsyncThunk('didManagement/createOutboundTrunk', async (params) => {
  try {
    const res = await DIDManagementAPI.createOutboundTrunk(params);
    displayMessage({ type: 'success', msg: 'Outbound trunk created successfully' });
    return res.data?.data;
  } catch (error) {
    displayMessage({ type: 'error', msg: error?.message });
  }
});

const updateOutboundTrunk = createAsyncThunk('didManagement/updateOutboundTrunk', async (params) => {
  try {
    const res = await DIDManagementAPI.updateOutboundTrunk(params);
    displayMessage({ type: 'success', msg: 'Outbound trunk updated successfully' });
    return res.data?.data;
  } catch (error) {
    displayMessage({ type: 'error', msg: error?.message });
  }
});

const deleteOutboundTrunk = createAsyncThunk('didManagement/deleteOutboundTrunk', async (id) => {
  try {
    const res = await DIDManagementAPI.deleteOutboundTrunk(id);
    displayMessage({ type: 'success', msg: 'Outbound trunk deleted successfully' });
    return res.data?.data;
  } catch (error) {
    displayMessage({ type: 'error', msg: error?.message });
  }
});

// Dispatch Rules Actions
const getDispatchRulesData = createAsyncThunk('didManagement/getDispatchRulesData', async ({ params, signal }) => {
  const res = await DIDManagementAPI.getDispatchRulesData(params, signal);
  return res?.data?.data;
});

const createDispatchRule = createAsyncThunk('didManagement/createDispatchRule', async (params) => {
  try {
    const res = await DIDManagementAPI.createDispatchRule(params);
    displayMessage({ type: 'success', msg: 'Dispatch rule created successfully' });
    return res.data?.data;
  } catch (error) {
    displayMessage({ type: 'error', msg: error?.message });
  }
});

const updateDispatchRule = createAsyncThunk('didManagement/updateDispatchRule', async (params) => {
  try {
    const res = await DIDManagementAPI.updateDispatchRule(params);
    displayMessage({ type: 'success', msg: 'Dispatch rule updated successfully' });
    return res.data?.data;
  } catch (error) {
    displayMessage({ type: 'error', msg: error?.message });
  }
});

const deleteDispatchRule = createAsyncThunk('didManagement/deleteDispatchRule', async (id) => {
  try {
    const res = await DIDManagementAPI.deleteDispatchRule(id);
    displayMessage({ type: 'success', msg: 'Dispatch rule deleted successfully' });
    return res.data?.data;
  } catch (error) {
    displayMessage({ type: 'error', msg: error?.message });
  }
});

const DIDManagementSlice = createSlice({
  name: 'didManagement',
  initialState: initialState,
  reducers: {
    resetState: () => {
      return initialState;
    },
    setDIDManagementCurrentPage: (state, action) => {
      state.pagination.currentPage = action.payload;
    },
    setDIDManagementPageSize: (state, action) => {
      state.pagination.pageSize = action.payload;
    },

    setCustomerDIDCurrentPage: (state, action) => {
      state.customerDid.pagination.currentPage = action.payload;
    },
    setCustomerDIDPageSize: (state, action) => {
      state.customerDid.pagination.pageSize = action.payload;
    },

    //inboundDID
    setInboundDIDCurrentPage: (state, action) => {
      state.inboundDID.pagination.currentPage = action.payload;
    },
    setInboundDIDPageSize: (state, action) => {
      state.inboundDID.pagination.pageSize = action.payload;
    },

    //inboundTrunks
    setInboundTrunksCurrentPage: (state, action) => {
      state.inboundTrunks.pagination.currentPage = action.payload;
    },
    setInboundTrunksPageSize: (state, action) => {
      state.inboundTrunks.pagination.pageSize = action.payload;
    },

    //outboundTrunks
    setOutboundTrunksCurrentPage: (state, action) => {
      state.outboundTrunks.pagination.currentPage = action.payload;
    },
    setOutboundTrunksPageSize: (state, action) => {
      state.outboundTrunks.pagination.pageSize = action.payload;
    },

    //dispatchRules
    setDispatchRulesCurrentPage: (state, action) => {
      state.dispatchRules.pagination.currentPage = action.payload;
    },
    setDispatchRulesPageSize: (state, action) => {
      state.dispatchRules.pagination.pageSize = action.payload;
    }
  },
  extraReducers: {
    [getDIDManagementData.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },
    [getDIDManagementData.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      state.pagination.totalRecords = action.payload?.count;
      state.data = action.payload?.results || [];
    },
    [getDIDManagementData.rejected]: (state, action) => {
      state.status = 'error';
      state.ui.loading = false;
      state.error = action.error.message;
    },
    [createDIDManagement.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },

    [createDIDManagement.fulfilled]: (state) => {
      state.status = 'idle';
      state.ui.loading = false;
    },

    [createDIDManagement.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },

    [updateDIDManagement.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },

    [updateDIDManagement.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      const updatedData = state.data.map((item) => {
        if (item.id === action.payload.id) {
          return action.payload;
        }
        return item;
      });
      state.data = updatedData;
    },

    [updateDIDManagement.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },

    [deleteDIDManagement.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },

    [deleteDIDManagement.fulfilled]: (state) => {
      state.status = 'idle';
      state.ui.loading = false;
    },

    [deleteDIDManagement.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },

    [getAllPublicDIDManagementData.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      state.customerDid.allPublicDIDData = action.payload;
    },

    [getCustomerDIDManagementData.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },
    [getCustomerDIDManagementData.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      state.customerDid.pagination.totalRecords = action.payload?.count;
      state.customerDid.data = action.payload?.results || [];
    },
    [getCustomerDIDManagementData.rejected]: (state, action) => {
      state.status = 'error';
      state.ui.loading = false;
      state.error = action.error.message;
    },
    [attachCustomerDIDManagement.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },

    [attachCustomerDIDManagement.fulfilled]: (state) => {
      state.status = 'idle';
      state.ui.loading = false;
    },

    [attachCustomerDIDManagement.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },

    [deleteCustomerDIDManagement.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },

    [deleteCustomerDIDManagement.fulfilled]: (state) => {
      state.status = 'idle';
      state.ui.loading = false;
    },

    [deleteCustomerDIDManagement.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },

    [getInboundDIDData.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },
    [getInboundDIDData.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      state.inboundDID.pagination.totalRecords = action.payload?.count;
      state.inboundDID.data = action.payload?.results || [];
    },
    [getInboundDIDData.rejected]: (state, action) => {
      state.status = 'error';
      state.ui.loading = false;
      state.error = action.error.message;
    },
    [createInboundDID.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },

    [createInboundDID.fulfilled]: (state) => {
      state.status = 'idle';
      state.ui.loading = false;
    },

    [createInboundDID.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },

    [updateInboundDID.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },

    [updateInboundDID.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      const updatedData = state.inboundDID.data.map((item) => {
        if (item.id === action.payload.id) {
          return action.payload;
        }
        return item;
      });
      state.inboundDID.data = updatedData;
    },

    [updateInboundDID.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },

    [deleteInboundDID.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },

    [deleteInboundDID.fulfilled]: (state) => {
      state.status = 'idle';
      state.ui.loading = false;
    },

    [deleteInboundDID.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },

    [getAllCustomersData.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      state.inboundDID.allCustomersData = action.payload;
    },

    // Inbound Trunks reducers
    [getInboundTrunksData.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },
    [getInboundTrunksData.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      state.inboundTrunks.pagination.totalRecords = action.payload?.count;
      state.inboundTrunks.data = action.payload || [];
    },
    [getInboundTrunksData.rejected]: (state, action) => {
      state.status = 'error';
      state.ui.loading = false;
      state.error = action.error.message;
    },

    [createInboundTrunk.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },
    [createInboundTrunk.fulfilled]: (state) => {
      state.status = 'idle';
      state.ui.loading = false;
    },
    [createInboundTrunk.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },

    [updateInboundTrunk.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },
    [updateInboundTrunk.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      const updatedData = state.inboundTrunks.data.map((item) => {
        if (item.id === action.payload.id) {
          return action.payload;
        }
        return item;
      });
      state.inboundTrunks.data = updatedData;
    },
    [updateInboundTrunk.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },

    [deleteInboundTrunk.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },
    [deleteInboundTrunk.fulfilled]: (state) => {
      state.status = 'idle';
      state.ui.loading = false;
    },
    [deleteInboundTrunk.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },

    // Outbound Trunks reducers
    [getOutboundTrunksData.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },
    [getOutboundTrunksData.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      state.outboundTrunks.pagination.totalRecords = action.payload?.count;
      state.outboundTrunks.data = action.payload || [];
    },
    [getOutboundTrunksData.rejected]: (state, action) => {
      state.status = 'error';
      state.ui.loading = false;
      state.error = action.error.message;
    },

    [createOutboundTrunk.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },
    [createOutboundTrunk.fulfilled]: (state) => {
      state.status = 'idle';
      state.ui.loading = false;
    },
    [createOutboundTrunk.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },

    [updateOutboundTrunk.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },
    [updateOutboundTrunk.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      const updatedData = state.outboundTrunks.data.map((item) => {
        if (item.id === action.payload.id) {
          return action.payload;
        }
        return item;
      });
      state.outboundTrunks.data = updatedData;
    },
    [updateOutboundTrunk.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },

    [deleteOutboundTrunk.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },
    [deleteOutboundTrunk.fulfilled]: (state) => {
      state.status = 'idle';
      state.ui.loading = false;
    },
    [deleteOutboundTrunk.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },

    // Dispatch Rules reducers
    [getDispatchRulesData.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },
    [getDispatchRulesData.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      state.dispatchRules.pagination.totalRecords = action.payload?.count;
      state.dispatchRules.data = action.payload || [];
    },
    [getDispatchRulesData.rejected]: (state, action) => {
      state.status = 'error';
      state.ui.loading = false;
      state.error = action.error.message;
    },

    [createDispatchRule.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },
    [createDispatchRule.fulfilled]: (state) => {
      state.status = 'idle';
      state.ui.loading = false;
    },
    [createDispatchRule.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },

    [updateDispatchRule.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },
    [updateDispatchRule.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      const updatedData = state.dispatchRules.data.map((item) => {
        if (item.sip_dispatch_rule_id === action.payload.sip_dispatch_rule_id) {
          return action.payload;
        }
        return item;
      });
      state.dispatchRules.data = updatedData;
    },
    [updateDispatchRule.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },

    [deleteDispatchRule.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },
    [deleteDispatchRule.fulfilled]: (state) => {
      state.status = 'idle';
      state.ui.loading = false;
    },
    [deleteDispatchRule.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    }
  }
});

const {
  resetState,
  setDIDManagementCurrentPage,
  setDIDManagementPageSize,
  setCustomerDIDCurrentPage,
  setCustomerDIDPageSize,
  setInboundDIDCurrentPage,
  setInboundDIDPageSize,
  setInboundTrunksCurrentPage,
  setInboundTrunksPageSize,
  setOutboundTrunksCurrentPage,
  setOutboundTrunksPageSize,
  setDispatchRulesCurrentPage,
  setDispatchRulesPageSize
} = DIDManagementSlice.actions;

export default DIDManagementSlice.reducer;

export {
  resetState,
  setDIDManagementCurrentPage,
  setDIDManagementPageSize,
  getDIDManagementData,
  createDIDManagement,
  updateDIDManagement,
  deleteDIDManagement,
  //Customer DID
  setCustomerDIDCurrentPage,
  setCustomerDIDPageSize,
  getAllPublicDIDManagementData,
  getCustomerDIDManagementData,
  attachCustomerDIDManagement,
  deleteCustomerDIDManagement,
  //Inbound DID
  setInboundDIDCurrentPage,
  setInboundDIDPageSize,
  getAllCustomersData,
  getInboundDIDData,
  createInboundDID,
  updateInboundDID,
  deleteInboundDID,
  //Inbound Trunks
  setInboundTrunksCurrentPage,
  setInboundTrunksPageSize,
  getInboundTrunksData,
  createInboundTrunk,
  updateInboundTrunk,
  deleteInboundTrunk,
  //Outbound Trunks
  setOutboundTrunksCurrentPage,
  setOutboundTrunksPageSize,
  getOutboundTrunksData,
  createOutboundTrunk,
  updateOutboundTrunk,
  deleteOutboundTrunk,
  //Dispatch Rules
  setDispatchRulesCurrentPage,
  setDispatchRulesPageSize,
  getDispatchRulesData,
  createDispatchRule,
  updateDispatchRule,
  deleteDispatchRule
};
